<template>
    <footer class="page-footer">
        <div class="footer-content">
            <div class="content footer-row">
                <div class="footer-column logo-column">
                    <div class="footer-logo">
                        <img src="https://static.app.staging.engelink.com.br/logos/Engelink.svg" alt="" />
                    </div>
                </div>
                <div class="footer-column text-column">
                    <div class="text">
                        <a @click="pushRoute({ url: 'Signup', solo: false })">Cadastre-se</a>
                    </div>
                    <div class="text">
                        <a @click="pushRoute({ url: 'CompetitionDashboardGuest', solo: false })">Sou fornecedor</a>
                    </div>
                    <div class="text">
                        <a @click="pushRoute({ url: 'LandingPage', solo: false })">CondoTechs</a>
                    </div>
                </div>
                <div class="footer-column text-column">
                    <div class="text">
                        <a @click="pushRoute({ url: 'ContactUs', solo: false })">Fale conosco</a>
                    </div>
                    <div class="text">
                        <a @click="openWindow('pageTermsOfUse')" class="terms-of-agreement-url"> Termos de uso</a>
                    </div>
                </div>
                <div class="footer-column info-column">
                    <div class="title working-hours-title">Horário de Funcionamento</div>
                    <div class="text">Segunda a sexta das 09h às 18h</div>
                </div>
            </div>
            <div class="content footer-row">
                © 2017-{{ new Date().getFullYear() }} Engelink Tecnologia LTDA. Todos os direitos reservados.
            </div>
        </div>
        <div class="help-mobile indigo darken-4 center-align hide">
            <p>
                Dúvidas?
                <a
                    class="btn white indigo-text indigo-text-darken-4"
                    @click="pushRoute({ url: 'LandingPage', solo: false })"
                    >Fale conosco.</a
                >
            </p>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    methods: {
        openWindow(name) {
            const routeData = this.$router.resolve({
                name
            });
            window.open(routeData.href, '_blank');
        },
        pushRoute(objectUrl) {
            if (objectUrl.solo) {
                window.open(objectUrl.url, '_blank');
            } else if (objectUrl.url && this.$route.name != objectUrl.url) {
                this.$router.push({ name: objectUrl.url });
            }
            this.show = false;
        }
    }
};
</script>
<style lang="scss" scoped>
footer.page-footer {
    width: 100%;
    height: 320px;
    background-color: #0e3d74;
    color: #fff;
    padding-top: 40px !important;
}

footer .footer-content .content {
    max-width: 1280px !important;
    margin-left: auto;
    margin-right: auto;
}

.footer-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.footer-content .footer-row {
    width: 100%;
}
.footer-content .footer-row:first-of-type {
    border-bottom: 0.5px solid #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 12px;
}
.footer-content .footer-row:last-of-type {
    padding-top: 20px;
    font-size: 12px;
    line-height: 17px;
}
.footer-content .footer-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.footer-content .footer-column:nth-child(1) {
    width: 22%;
}
.footer-content .footer-column:nth-child(2),
.footer-content .footer-column:nth-child(3) {
    width: 12%;
}
.footer-content .footer-column:nth-child(4) {
    width: 18%;
}
.footer-content .footer-column.logo-column .footer-logo {
    margin-bottom: 14px;
}
.footer-content .footer-column.logo-column .footer-logo img {
    width: 140px;
}
.footer-content .footer-column.logo-column .logo-text {
    font-size: 12px;
    line-height: 16px;
    text-align: left;
}
.footer-content .footer-column.text-column {
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: left;
}
.footer-content .footer-column.text-column .text {
    margin-bottom: 16px;
    cursor: pointer;
}
.footer-content .footer-column.text-column .text a,
.footer-content .footer-column.info-column .text a {
    color: #fff !important;
}
.footer-content .footer-column.info-column .title {
    color: #fdc30c;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
}
.footer-content .footer-column.info-column .title:nth-child(2) {
    margin-top: 20px;
    margin-bottom: 5px;
}
.footer-content .footer-column.info-column .text {
    line-height: 20px;
    margin-bottom: 5px;
}

@media screen and (max-width: 1366px) {
    footer .footer-content .content {
        max-width: 90% !important;
    }
}

@media screen and (max-width: 992px) {
    footer.page-footer {
        height: 440px;
    }

    .footer-content .footer-row:first-of-type {
        flex-direction: column;
        align-items: center;
        padding-bottom: 30px;
    }
    .footer-content .footer-row:last-of-type {
        padding-top: 20px;
        text-align: center;
        width: 64%;
    }
    .footer-content .footer-row .footer-column {
        width: 100%;
        text-align: center;
        align-items: center;
    }
    .footer-content .footer-column.info-column .title {
        margin-top: 20px;
    }
    .footer-content .footer-column.text-column .text {
        margin-bottom: 8px;
    }
}
</style>
